module.exports = __webpack_public_path__ + "static/img/sedan-green.a16718e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sedan-green.svg
// module id = gosM
// module chunks = 74